// extracted by mini-css-extract-plugin
module.exports = {"Treatment":"treatment-module--Treatment--2U83k","divider":"treatment-module--divider--1o8n4"};